<template>
  <div class="process-item">
    <div class="process-item-top">
      <p>
        <span class="process-item-time">{{ info.createTime | formatTime }}</span>
        <span class="process-item-status" :class="{ normal: +info.ticketStatus === 3 }">{{
          ticketStatus
        }}</span>
      </p>
    </div>
    <div class="process-item-main" @click="jumpToProcessDetail">
      <div
        class="process-item-img"
        :style="{ backgroundImage: `url('${$setPicSize(info.pic)}')` }"
      ></div>
      <div class="process-item-content">
        <p class="process-item-title">{{ info.ticketTitle }}</p>
        <p class="process-item-sub">{{ info.ticketDesc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'
export default {
  name: 'ProcessItem',
  props: ['info'],
  data() {
    return {
      msg: ''
    }
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD') : ''
    }
  },
  computed: {
    ticketStatus() {
      const statusMap = {
        1: '处理中',
        2: '处理中',
        3: '已完成',
        4: '处理中'
      }
      return statusMap[this.info.ticketStatus] || ''
    }
  },
  methods: {
    $setPicSize(url) {
      // 后台没有返回地址给个默认的
      if (!url) {
        return setPicSize(
          'https://pic6.zhuanstatic.com/zhuanzh/21d599a8-f720-479b-b90e-b9560bd9810d.png',
          100,
          100
        )
      }
      // 部分后台返回的图片url非常规url，不做处理直接用
      const reg = /\.(png|jpg|jpeg|gif)/i
      return reg.test(url) ? setPicSize(url, 300, 200) : url
    },
    jumpToProcessDetail() {
      const { orderId = '' } = this.info
      console.log(orderId)
      this.$router.push({
        name: 'serviceProcessDetail',
        params: {
          ticketId: this.info.ticketId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
